import alt from 'js/alt';
import { criteriaStore } from 'stores/CriteriaStore';
import { criteriaActions } from 'actions/CriteriaActions';
import { reportActions } from 'actions/ReportActions';
import { mapActions } from 'actions/MapActions';

import { Promise as bbPromise } from 'promise';
import _ from 'lodash';

import { loads } from 'js/config/config';
import { buildReport } from 'utils/FullReport';

import queryIce from './queries/ice';
import queryRain from './queries/rain';
import querySnow from './queries/snow';
import querySeismic from './queries/seismic';
import queryWind from './queries/wind';
import queryTsunami from './queries/tsunami';
import queryFloodFHZ from './queries/flood';
import queryTornado from './queries/tornado';

class ReportStore {
  constructor() {
    this.loads = loads;
    this.showLoad = {};
    this.detailsPopupVisible = false;
    this.reportBuildingPopupVisible = false;
    this.loadTimeoutPopupVisible = false;
    this.loadWindDataWarningPopupVisible = false;
    this.librariesLoaded = false;
    this.queriesComplete = false;
    this.elevation = 0;
    this.elevationReferenceDatum = '';
    this.showSummary = false;
    this.reportIsBuilding = false;
    this.reportError = false;
    this.errorMessage = '';

    this.bindListeners({
      analyzeForReport: criteriaActions.viewReport,
      updateAndShowLoadDetails: reportActions.updateAndShowLoadDetails,
      closePopup: reportActions.closePopup,
      buildReport: reportActions.buildReport,
      reportLibrariesLoaded: reportActions.reportLibrariesLoaded,
      setElevation: mapActions.setElevation,
      setElevationReferenceDatum: mapActions.setElevationReferenceDatum,
      // updateLoadsVisibility: mapActions.updateLayerVisibility,
      closeReportBuildPopup: reportActions.closeReportBuildPopup,
      showReportBuildPopup: reportActions.showReportBuildPopup,
      showLoadTimeoutPopup: reportActions.showLoadTimeoutPopup,
      closeLoadTimeoutPopup: reportActions.closeLoadTimeoutPopup,
      showWindDataWarningPopup: reportActions.showWindDataWarningPopup,
      closeWindDataWarningPopup: reportActions.closeWindDataWarningPopup,
      showSummaryF: reportActions.showSummary,
      closeSummary: reportActions.closeSummary,
      togglePreloader: reportActions.togglePreloader,
    });
  }

  closeSummary() {
    this.setState({ showSummary: false });
  }

  togglePreloader(bool) {
    this.reportIsBuilding = bool;
  }

  showSummaryF() {
    this.setState({ showSummary: true });
  }

  showLoadTimeoutPopup() {
    this.setState({ loadTimeoutPopupVisible: true });
  }

  closeLoadTimeoutPopup() {
    this.setState({ loadTimeoutPopupVisible: false });
  }

  showWindDataWarningPopup() {
    this.setState({ loadWindDataWarningPopupVisible: true });
  }

  closeWindDataWarningPopup() {
    this.setState({ loadWindDataWarningPopupVisible: false });
  }

  showReportBuildPopup(params) {
    const { error } = params;
    this.setState({
      reportBuildingPopupVisible: true,
      errorMessage: error ? error : '',
      reportError: !!error,
    });
  }

  closeReportBuildPopup() {
    this.setState({
      reportBuildingPopupVisible: false,
      errorMessage: '',
      reportError: false,
    });
  }

  setElevation(elevation) {
    this.setState({ elevation: elevation });
  }

  setElevationReferenceDatum(datumCode) {
    let datum;
    switch (datumCode) {
      case '0':
        datum = 'Unknown';
        break;
      case '1':
        datum = 'Local Mean Sea Level';
        break;
      case '29':
        datum = 'National Geodetic Vertical Datum of 1929 (NGVD 29)';
        break;
      case '88':
        datum = 'North American Vertical Datum of 1988 (NAVD 88)';
        break;
      case '99':
        datum = 'Other';
        break;
      case '-1000000':
        datum = '';
        break;
      // case 'hawaii':
      //   datum = 'Mean High Water (MHW) datum';
      //   break;
    }
    this.setState({ elevationReferenceDatum: datum });
  }

  reportLibrariesLoaded() {
    this.setState({ librariesLoaded: true });
  }

  closePopup() {
    this.detailsPopupVisible = false;
    this.showLoad = {};
  }

  updateAndShowLoadDetails(load) {
    this.showLoad = load;
    this.detailsPopupVisible = true;
  }

  queryLoads() {
    let location = {
      lat: parseFloat(criteriaStore.getState().latitude),
      long: parseFloat(criteriaStore.getState().longitude),
    };
    //here we get all the loads information;
    let promises = [];

    _.forEach(this.loads, (load) => {
      if (load.checked !== 'checked') {
        return;
      }

      switch (load.label) {
        case 'Ice':
          promises.push(queryIce(location, load).timeout(30000));
          break;
        case 'Rain':
          promises.push(queryRain(location, load).timeout(30000));
          break;
        case 'Snow':
          promises.push(querySnow(location, load).timeout(30000));
          break;
        case 'Seismic':
          promises.push(querySeismic(location, load).timeout(30000));
          break;
        case 'Tsunami':
          promises.push(queryTsunami(location, load).timeout(30000));
          break;
        case 'Wind':
          promises.push(queryWind(location, load).timeout(30000));
          break;
        case 'Flood':
          promises.push(queryFloodFHZ(location, load).timeout(30000));
          break;
        case 'Tornado':
          promises.push(queryTornado(location, load).timeout(120000));
          break;
        default:
          break;
      }
    });
    bbPromise.all(promises.map((p) => p.catch((e) => e))).then((resultsArray) => {
      // resultsArray is an array of the objects returned from each resolved function in our promises array
      resultsArray.forEach((result) => {
        if (result.hasOwnProperty('error') || (result.name && result.name === 'TimeoutError')) {
          reportActions.showLoadTimeoutPopup();
        }
      });

      const loadsExpected = this.loads.filter((load) => load.checked === 'checked').map((load) => load.label);
      const succeededLoads = resultsArray
        .filter((result) => !!result.load && !result.error)
        .map((succeededResult) => succeededResult.load);
      const failedLoads = loadsExpected.filter((load) => !succeededLoads.includes(load));
      if (failedLoads.length > 0) {
        failedLoads.forEach((failedLoad) => {
          this.loads.find((load) => load.label === failedLoad).sampleData.value = ['Failed'];
        });
      }

      this.queriesComplete = true;
      this.emitChange();
    });
  }

  analyzeForReport() {
    //update the loads from criteriaStore
    this.loads = _.cloneDeep(criteriaStore.getState().loads);

    // here we calc all the stuff for the report
    this.queryLoads();
  }

  buildReport() {
    buildReport(this, criteriaStore);
  }

  updateLoadsVisibility(updateObj) {
    this.loads.map((load) => {
      if (load.label === updateObj.id) {
        load.visible = updateObj.checked;
      } else {
        load.visible = false;
      }
    });
  }
}

export const reportStore = alt.createStore(ReportStore, 'ReportStore');
